// import { NgModule } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { ProfilecardComponent } from './profilecard/profilecard.component';
// import { ProfilepageComponent } from './profilepage/profilepage.component';
// import { UserphotocardComponent } from './userphotocard/userphotocard.component';
// import { EditprofileComponent } from './editprofile/editprofile.component';
// import { LoadingscreenComponent } from './loadingscreen/loadingscreen.component';
// import { NotificationListDialogComponent } from './notification-list-dialog/notification-list-dialog.component';

// import { MatCardModule } from '@angular/material/card';
// import { MatButtonModule } from '@angular/material/button';
// import { MatFormFieldModule } from '@angular/material/form-field';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { MatIconModule } from '@angular/material/icon';
// import { MatRadioModule } from '@angular/material/radio';
// import { SharedModule } from '../shared/shared.module';
// import { PopupconfirmComponent } from './popupconfirm/popupconfirm.component';
// import { MatDividerModule } from '@angular/material/divider';
// import { MatDialogModule } from '@angular/material/dialog';
// import { MatTooltipModule } from '@angular/material/tooltip';
// import { MatOptionModule } from '@angular/material/core';
// import { MatSelectModule } from '@angular/material/select';
// import { PopupaddcategoryComponent } from './popupaddcategory/popupaddcategory.component';
// import { MatListModule } from '@angular/material/list';
// import { PopupsuccesscardComponent } from './popupsuccesscard/popupsuccesscard.component';
// import { PopupselectComponent } from './popupselect/popupselect.component';
// import { CustompopupselectComponent } from './custompopupselect/custompopupselect.component';
// import { MatCheckboxModule } from '@angular/material/checkbox';
// import { PopupdocuplaodComponent } from './popupdocuplaod/popupdocuplaod.component';
// import { CustomfileuploadComponent } from './customfileupload/customfileupload.component';
// import { DateandtimeselectionModule } from './dateandtimeselection/dateandtimeselection.module';
// import { VehiclePlanDialogComponent } from './vehicle-plan-dialog/vehicle-plan-dialog.component';
// import { MatTabsModule } from '@angular/material/tabs';
// import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
// import { MatProgressBarModule } from '@angular/material/progress-bar';
// import { LpoViewerDialogComponent } from './lpo-viewer-dialog/lpo-viewer-dialog.component';
// import { MatInputModule } from '@angular/material/input';

// import { InvoiceTemplateDialogComponent } from './invoice-template-dialog/invoice-template-dialog.component';
// import { UploadDocumentDialogComponent } from './upload-document-dialog/upload-document-dialog.component';
// import { ReferVendorDialogComponent } from './refer-vendor-dialog/refer-vendor-dialog.component';
// import { TermsDialogComponent } from './terms-dialog/terms-dialog.component';
// import { VendorsTermsComponent } from './vendors-terms/vendors-terms.component';
// import { GeneralTermsComponent } from './general-terms/general-terms.component';
// import { RejectionReasonDialogComponent } from './rejection-reason-dialog/rejection-reason-dialog.component';

// @NgModule({
//   declarations: [
//     ProfilecardComponent,
//     ProfilepageComponent,
//     UserphotocardComponent,
//     EditprofileComponent,
//     LoadingscreenComponent,
//     PopupselectComponent,
//     PopupconfirmComponent,
//     PopupaddcategoryComponent,
//     PopupsuccesscardComponent,
//     CustompopupselectComponent,
//     PopupdocuplaodComponent,
//     CustomfileuploadComponent,
//     VehiclePlanDialogComponent,
//     LpoViewerDialogComponent,
//     InvoiceTemplateDialogComponent,
//     UploadDocumentDialogComponent,
//     NotificationListDialogComponent,
//     ReferVendorDialogComponent,
//     TermsDialogComponent,
//     VendorsTermsComponent,
//     GeneralTermsComponent,
//   ],
//   imports: [
//     CommonModule,
//     MatCardModule,
//     MatButtonModule,
//     FormsModule,
//     MatFormFieldModule,
//     ReactiveFormsModule,
//     MatIconModule,
//     MatRadioModule,
//     SharedModule,
//     MatDividerModule,
//     MatDialogModule,
//     MatTooltipModule,
//     MatOptionModule,
//     MatSelectModule,
//     MatListModule,
//     MatCheckboxModule,
//     DateandtimeselectionModule,
//     MatTabsModule,
//     MatProgressSpinnerModule,
//     MatProgressBarModule,
//     MatInputModule,
//     RejectionReasonDialogComponent,
//   ],
//   exports: [
//     ProfilecardComponent,
//     UserphotocardComponent,
//     PopupaddcategoryComponent,
//     CustomfileuploadComponent,
//     UploadDocumentDialogComponent,
//     DateandtimeselectionModule,
//     TermsDialogComponent,
//     VendorsTermsComponent,
//     GeneralTermsComponent,
//   ],
// })
// export class ComponentsModule {}






import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfilecardComponent } from './profilecard/profilecard.component';
import { ProfilepageComponent } from './profilepage/profilepage.component';
import { UserphotocardComponent } from './userphotocard/userphotocard.component';
import { EditprofileComponent } from './editprofile/editprofile.component';
import { LoadingscreenComponent } from './loadingscreen/loadingscreen.component';
import { NotificationListDialogComponent } from './notification-list-dialog/notification-list-dialog.component';

import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { SharedModule } from '../shared/shared.module';
import { PopupconfirmComponent } from './popupconfirm/popupconfirm.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { PopupaddcategoryComponent } from './popupaddcategory/popupaddcategory.component';
import { MatListModule } from '@angular/material/list';
import { PopupsuccesscardComponent } from './popupsuccesscard/popupsuccesscard.component';
import { PopupselectComponent } from './popupselect/popupselect.component';
import { CustompopupselectComponent } from './custompopupselect/custompopupselect.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PopupdocuplaodComponent } from './popupdocuplaod/popupdocuplaod.component';
import { CustomfileuploadComponent } from './customfileupload/customfileupload.component';
import { DateandtimeselectionModule } from './dateandtimeselection/dateandtimeselection.module';
import { VehiclePlanDialogComponent } from './vehicle-plan-dialog/vehicle-plan-dialog.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LpoViewerDialogComponent } from './lpo-viewer-dialog/lpo-viewer-dialog.component';
import { MatInputModule } from '@angular/material/input';
import { InvoiceTemplateDialogComponent } from './invoice-template-dialog/invoice-template-dialog.component';
import { UploadDocumentDialogComponent } from './upload-document-dialog/upload-document-dialog.component';
import { ReferVendorDialogComponent } from './refer-vendor-dialog/refer-vendor-dialog.component';
import { TermsDialogComponent } from './terms-dialog/terms-dialog.component';
import { VendorsTermsComponent } from './vendors-terms/vendors-terms.component';
import { GeneralTermsComponent } from './general-terms/general-terms.component';
import { RejectionReasonDialogComponent } from './rejection-reason-dialog/rejection-reason-dialog.component';
import { VehicleBookingStatsCardComponent } from '../views/servicemanagerview/vehicle-booking-stats-card/vehicle-booking-stats-card.component';
import { SubscriptionSummaryCardComponent } from '../subscription-summary-card/subscription-summary-card.component';
import { PayExtraBookingDialogComponent } from './pay-extra-booking-dialog/pay-extra-booking-dialog.component';

@NgModule({
  declarations: [
    ProfilecardComponent,
    ProfilepageComponent,
    UserphotocardComponent,
    EditprofileComponent,
    LoadingscreenComponent,
    PopupselectComponent,
    PopupconfirmComponent,
    PopupaddcategoryComponent,
    PopupsuccesscardComponent,
    CustompopupselectComponent,
    PopupdocuplaodComponent,
    CustomfileuploadComponent,
    VehiclePlanDialogComponent,
    LpoViewerDialogComponent,
    InvoiceTemplateDialogComponent,
    UploadDocumentDialogComponent,
    NotificationListDialogComponent,
    ReferVendorDialogComponent,
    TermsDialogComponent,
    VendorsTermsComponent,
    GeneralTermsComponent,
    SubscriptionSummaryCardComponent,
    PayExtraBookingDialogComponent,
    // NOTE: RejectionReasonDialogComponent is NOT declared here because it is
    // a standalone component — it belongs in imports only (see below).
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatIconModule,       // fixes [ngClass] on <i> AND mat-icon in VendorsTermsComponent
    MatRadioModule,
    SharedModule,
    MatDividerModule,
    MatDialogModule,
    MatTooltipModule,
    MatOptionModule,
    MatSelectModule,
    MatListModule,
    MatCheckboxModule,
    DateandtimeselectionModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatInputModule,
    RejectionReasonDialogComponent, // standalone component — imported, not declared
  ],
  exports: [
    ProfilecardComponent,
    UserphotocardComponent,
    PopupaddcategoryComponent,
    CustomfileuploadComponent,
    UploadDocumentDialogComponent,
    DateandtimeselectionModule,
    TermsDialogComponent,
    VendorsTermsComponent,
    GeneralTermsComponent,
    LoadingscreenComponent,         // exported so other modules can use it
    VehiclePlanDialogComponent,     // exported so it can be opened via MatDialog anywhere
    SubscriptionSummaryCardComponent,
    PayExtraBookingDialogComponent,
  ],
})
export class ComponentsModule { }